<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">系统管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="owner">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 业主管理
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="业主单位">
                <el-input placeholder="请输入业主单位" v-model="seefrom.name"></el-input>
              </el-form-item>
              <el-form-item label="区域选择">
                <el-input
                  placeholder="请选择区域"
                  v-model="seefrom.curAreaName"
                  @focus="changeAreaMode(1)"
                ></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/owner/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="owner"
          >
            <template slot="last">
              <el-table-column label="业主图片" prop="ownPicList" :formatter="getPic">
                <template slot-scope="scope">
                  <div v-if="scope.row.ownPicList.length === 0">无</div>
                  <div v-else>
                    <el-image
                      style="width: 60px; height: 60px;cursor: pointer;"
                      :key="0"
                      :src="
                        scope.row.ownPicList[0].url
                          ? scope.row.ownPicList[0].url.replaceAll(
                              variable.fileUrl,
                              variable.SSL_HOST + '/file/'
                            )
                          : ''
                      "
                      @click.native="see(scope.$index, scope.row)"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="关联区域"
                prop="areaList"
                :formatter="getArea"
              ></el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.$index, scope.row)"
                    >编辑</el-link
                  >
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteMsg(scope.$index, scope.row)"
                    >删除</el-link
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
            <el-form-item label="业主单位" prop="name">
              <el-input v-model.trim="addEquipment.name"></el-input>
            </el-form-item>
            <el-form-item label="值班人员" prop="watchkeeper">
              <el-input v-model.trim="addEquipment.watchkeeper"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="phone">
              <el-input v-model.trim="addEquipment.phone"></el-input>
            </el-form-item>
            <el-form-item label="业主描述" prop="descripe">
              <el-input v-model.trim="addEquipment.descripe"></el-input>
            </el-form-item>
            <el-form-item label="业主图片">
              <el-upload-secondary
                class="YnormalCard"
                v-model="addEquipment.fileList"
                list-type="picture-card"
                accepts="jpg,jpeg,png"
              >
                <i class="el-icon-plus"></i>
              </el-upload-secondary>
              <div
                class="el-form-item__error"
                v-show="!addEquipment.fileList || addEquipment.fileList.length == 0"
                slot="error"
              >
                请上传图片
              </div>
            </el-form-item>
            <el-form-item label="关联区域">
              <el-tree
                :data="treeData"
                show-checkbox
                node-key="id"
                :check-strictly="true"
                :props="defaultProps"
                :filter-node-method="filterNode"
                :default-checked-keys="checkAreas"
                ref="tree"
              ></el-tree>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog
          class="editDialog seePic"
          :visible.sync="displaySeeForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <!-- <img v-default-img v-for="(item, index) in this.seePicList" height="100px" width="100px" :key="index" :src="item" alt /> -->
          <el-image
            style="width: 100px; height: 100px; z-index: 9999 !important;"
            v-for="(item, index) in seePicList"
            :preview-src-list="seePicList"
            :key="index"
            :src="item"
          ></el-image>
        </el-dialog>
        <!-- 区域树 -->
        <mountPoint
          :hasChildNodes="areaTreeMode"
          :dialogVisible="areaTreeVisible"
          @regionTreeClose="areaTreeVisible = false"
          @regionTreeData="selRegionData"
        ></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { dt, obj2urlsp } from 'utils'

  export default {
    data() {
      return {
        rules: {
          name: [
            {
              required: true,
              message: '请输入业主单位',
              trigger: 'blur'
            }
          ]
        },
        treeData: [],
        defaultProps: {
          children: 'areas',
          label: 'name',
          disabled: 'isSelected'
        },
        id: '',
        displayForm: false,
        displaySeeForm: false,
        title: '',
        tabName: 'owner',
        form_jsgl: {},
        other: {},
        items: [],
        seefrom: {
          name: '',
          curAreaName: '',
          region_id: ''
        },
        addEquipment: {
          name: '',
          watchkeeper: '',
          phone: '',
          descripe: '',
          fileList: []
        },
        checkAreas: [],
        areaIdList: [],
        //区域树是否显示
        areaTreeVisible: false,
        //区域树模式选择
        areaTreeMode: true,
        //选择区域树模式 查询 ？ 新增 ？
        areaMode: 1,
        picUrl: '',
        //紧用
        selects: [],
        seePicList: [],
        variable: process.env
      }
    },
    computed: {
      self() {
        return this
      },
      config() {
        return [
          {
            prop: 'name',
            label: '业主单位'
          },
          {
            prop: 'watchkeeper',
            label: '值班人员'
          },
          {
            prop: 'phone',
            label: '联系方式'
          },
          {
            prop: 'descripe',
            label: '业主描述'
          }
        ]
      },
      dt() {
        return dt.map(({ label }) => label)
      }
    },
    components: {
      normalNav: () => import('public/normalNav'),
      searchForm: () => import('public/searchForm'),
      easyTable: () => import('public/easyTable'),
      mountPoint: () => import('public/mountPoint')
    },
    methods: {
      getPic(val) {
        if (val.ownPicList.length > 0) {
          let getPic = []
          val.ownPicList.forEach(element => {
            getPic.push(element.name)
          })
          return getPic.join(',')
        }
      },
      getArea(val) {
        if (val.areaList.length > 0) {
          let getArea = []
          val.areaList.forEach(element => {
            getArea.push(element.areaName)
          })
          return getArea.join(',')
        }
      },
      //选择区域模式变化
      changeAreaMode(mode) {
        this.areaTreeVisible = true
        if (mode === 1) this.areaTreeMode = true
        if (mode === 2) this.areaTreeMode = false
        this.areaMode = mode
      },
      //区域树选择完回调
      selRegionData(a, ...b) {
        let mode = this.areaMode
        if (mode === 1) {
          this.seefrom.region_id = a.id
          this.seefrom.curAreaName = a.name
        } else if (mode === 2) {
          if (!a.type || a.type !== 1) {
            this.$set(this.addEquipment, 'region', null)
            this.addEquipment.regionName = ''
            return
          }
          this.$set(this.addEquipment, 'region', a.id)
          this.addEquipment.regionName = a.name
        }
      },
      filterNode(value, data, node) {
        return value.some(id => id == data.id)
      },
      //区域树
      getTreeData() {
        this.$axiosget('operation/owner/getSelectedAreaList', {
          params: {
            ownerId: this.id
          }
        }).then(res => {
          this.treeData = res.data.data
        })
      },
      //搜索
      subSeefrom() {
        this.other = this.seefrom
        this.other.areaId = this.seefrom.region_id
        this.$refs.owner.pageToOne()
        this.$nextTick(this.$refs.owner.getData)
      },
      //重置
      reset() {
        // this.seefrom.name = "";
        // this.seefrom.curAreaName = "";
        // this.seefrom.region_id = "";
        this.seefrom = {}
      },
      //新增
      addnew() {
        this.title = '新增业主信息'
        this.state = 1
        this.displayForm = true
        this.getTreeData()
        this.addEquipment = {
          name: '',
          watchkeeper: '',
          phone: '',
          descripe: ''
        }
        this.checkAreas = []
        this.$nextTick(() => {
          this.$refs['addEquipment'].clearValidate()
        })
      },
      //查看图片
      see(index, row) {
        this.displaySeeForm = true
        this.title = '查看业主图片'
        this.seePicList = []
        row.ownPicList.forEach(o => {
          this.seePicList.push(
            o.url.startsWith('https')
              ? o.url
              : o.url.replaceAll(process.env.fileUrl, process.env.SSL_HOST + '/file')
          )
        })
      },
      //编辑
      edit(index, row) {
        this.id = row.id
        this.checkAreas = []
        this.title = '修改业主信息'
        this.state = 2
        this.displayForm = true
        this.getTreeData()
        this.addEquipment.name = row.name
        this.addEquipment.watchkeeper = row.watchkeeper
        this.addEquipment.phone = row.phone
        this.addEquipment.descripe = row.descripe
        this.picUrl = row.ownPicList
        let picArr = []
        row.ownPicList.forEach(o => {
          picArr.push({
            name: o.name,
            url: o.url.startsWith('https')
              ? o.url
              : o.url.replaceAll(process.env.fileUrl, process.env.SSL_HOST + '/file/')
          })
        })
        console.log(picArr)
        this.addEquipment.fileList = picArr
        row.areaList.forEach(element => {
          this.checkAreas.push(element.area_id)
        })
        this.$nextTick(() => {
          this.$refs['addEquipment'].clearValidate()
        })
      },
      //确认
      submitAdd() {
        this.areaIdList = []
        let areaIds = this.$refs.tree
          .getHalfCheckedKeys()
          .concat(this.$refs.tree.getCheckedKeys())
          .toString()
        let areaArr = areaIds.split(',')
        areaArr.forEach(element => {
          if (element !== '') {
            this.areaIdList.push({ area_id: element })
          }
        })
        this.$refs.addEquipment.validate(valid => {
          if (valid) {
            if (this.state === 1) {
              let file = this.addEquipment.fileList
              let ownPicList = []
              if (file) {
                file.forEach(element => {
                  if (element.response.data !== undefined) {
                    ownPicList.push({
                      name: element.name,
                      url: element.response.data[0].startsWith('http')
                        ? element.response.data[0]
                        : process.env.fileUrl + '/' + element.response.data[0]
                    })
                  }
                })
              }
              this.$axiospost('operation/owner/save', {
                name: this.addEquipment.name,
                watchkeeper: this.addEquipment.watchkeeper,
                phone: this.addEquipment.phone,
                descripe: this.addEquipment.descripe,
                areaIdList: this.areaIdList,
                ownPicList: ownPicList
              }).then(res => {
                if (res.data.status === '10000') {
                  this.displayForm = false
                  this.subSeefrom()
                }
              })
            } else if (this.state === 2) {
              // //console.log(this.picUrl, "this.file1");
              let ownPicList1 = []
              let file = this.addEquipment.fileList
              if (file) {
                file.forEach(element => {
                  if (element.response === undefined || element.response.status !== -10000) {
                    ownPicList1.push({
                      name: element.name,
                      url: element.response
                        ? element.response.data[0].startsWith('http')
                          ? element.response.data[0]
                          : process.env.fileUrl + '/' + element.response.data[0]
                        : element.url
                    })
                  }
                })
              }
              console.log(ownPicList1)
              // }
              this.$axiospost('operation/owner/update', {
                id: this.id,
                name: this.addEquipment.name,
                watchkeeper: this.addEquipment.watchkeeper,
                phone: this.addEquipment.phone,
                descripe: this.addEquipment.descripe,
                areaIdList: this.areaIdList,
                ownPicList: ownPicList1
              }).then(res => {
                if (res.data.status === '10000') {
                  this.displayForm = false
                  this.subSeefrom()
                }
              })
            }
          }
        })
      },
      //删除
      deleteMsg(index, row) {
        var formData = new FormData()
        formData.append('id', row.id)
        this.$confirm('是否删除该业主?', '删除操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$axiosdelete('operation/owner/delete', {
              params: {
                id: row.id
              }
            }).then(res => {
              if (res.data.status === '10000') {
                this.subSeefrom()
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              }
            })
          })
          .catch(() => {})
      }
    },
    created() {
      this.$axiosget('operation/owner/findAll').then(res => {
        this.selects = res.data.data.isSelected
      })
    }
  }
</script>

<style scoped lang="less">
  .seePic {
    img {
      margin-left: 10px;
      margin-bottom: 20px;
    }
  }
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    z-index: 99;
  }
  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
  .checkbox-usergroup {
    margin-left: 100px;
  }
  .editDialog .el-form-item .el-tree {
    background: transparent;
    color: #cacaca;
    border: 1px solid #3d4963;
    width: 310px;
    max-height: 360px;
    min-height: 30px;
    padding: 5px 0 5px 0;
    overflow-y: scroll;
  }
  .editDialog .el-form-item .el-tree .el-tree-node__content:hover {
    background-color: transparent;
  }
  .editDialog .el-form-item .el-tree::-webkit-scrollbar {
    width: 0;
  }
  /deep/ .el-image-viewer__wrapper {
    z-index: 9999 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/system/owner/index.vue